module.exports = __webpack_public_path__ + "static/media/Europe.3b9c551e.svg";